import { h, defineComponent } from 'vue';
import { upgradeOrSubscribeButton } from '@/ui/components/upgrade/UpgradeOrSubscribeButton';
import { UpgradeAdDropdown } from '@/ui/components/upgrade/UpgradeAdDropdown';
import { Button } from '../Button';
import { starsIcon } from '@/ui/components/icon/icons';

interface UpgradeAdProps {
  message: string;
  withDropdown?: boolean;
  placeholder?: string;
  classes?: Array<string>;
  isVertical?: boolean;
  withButton?: boolean;
}

export const UpgradeAd = defineComponent<UpgradeAdProps>({
  name: 'UpgradeAd',
  props: {
    message: {
      type: String,
      required: true,
    },
    classes: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    isVertical: {
      type: Boolean,
      required: false,
      default: false,
    },
    withDropdown: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    withButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const defaultField = h(UpgradeAdDropdown, {
      props: { placeholder: props.placeholder ?? '' },
    });

    return function render() {
      return h('div', {
        class: `upgrade-ad ${props.classes ? props.classes.join(' ') : ''}`,
        scopedSlots: {
          fields: () => defaultField,
        },
      }, [
        props.withDropdown && (
          ('fields' in context.slots)
            ? h('div', { class: 'upgrade-ad__fields' }, context.slots.fields?.())
            : defaultField
        ),
        props.withButton && (
          h('div', { class: 'upgrade-ad__with-button' }, [
            h(Button, { props: { outlined: true, disabled: true } }, [
              starsIcon(),
              props.placeholder ?? '',
            ]),
          ])
        ),
        h('div', { class: `upgrade-ad-message ${props.isVertical ? 'upgrade-ad-message--is-vertical' : ''}` }, [
          h('div', { class: 'upgrade-ad-message__text' }, props.message ?? ''),
          context.slots.upgradeButton
            ? context.slots.upgradeButton()
            : upgradeOrSubscribeButton({
              classes: 'upgrade-ad-message__button',
            }),
        ]),
      ]);
    };
  },
});

export const upgradeAd = ({
  message,
  isVertical,
  withButton,
  placeholder,
}: Pick<UpgradeAdProps, 'message' | 'isVertical' | 'withButton' | 'placeholder'>) => h(
  UpgradeAd, {
    props: { message, isVertical, withButton, placeholder },
  },
);
